import { useAppDispatch } from "Store/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { initialUser } from "../addEditUser/intialValues";
import { setCurrentUser, setIsUserModalOpen } from "../redux/slice";
import { Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import "Features/Users/users.index.css";

interface UsersToolbarProps {
  searchText: string;
  onSearchChange: (value: string) => void;
}

const UsersToolbar = ({ searchText, onSearchChange }: UsersToolbarProps) => {
  const dispatch = useAppDispatch();
  return (
    <div
      style={{
        justifyContent: "space-between",
        display: "flex",
        flexDirection: "row-reverse",
        margin: "5px",
        alignItems: "center",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <Input
          placeholder="Search users..."
          prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
          allowClear
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ width: 260 }}
        />
        <Button
          type="primary"
          className="add-organization-button"
          onClick={() => {
            dispatch(setCurrentUser(initialUser));
            dispatch(setIsUserModalOpen(true));
          }}
        >
          <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faPlus} />
          Add User
        </Button>
      </div>
      <div className="organization-heading">Users</div>
    </div>
  );
};

export default UsersToolbar;